<template>
  <div class="mypackage">
    <div class="title">
      <span :class="{'curspan':pack==index}" v-for="(item,index) in tabs" :key="index" >{{item}}</span>
      <!--<select class="selection-component" v-model="ProductActive" @change="changeProduct($event)" v-show="bol1">
        <option value="0" style="color:#000">全部年份</option>
        <option :value="a" v-for="(a,index) in kecheng_year" style="color:#000">{{a}}年</option>
      </select>
      <select class="selection-component" @change="changeProducts($event)" v-model="ProductActives" v-show="bol2">
        <option value="0" style="color:#000">全部分类</option>
        <option :value="b.id" v-for="(b,index) in kecheng_type" style="color:#000">{{b.name}}</option>
      </select>-->
    </div>
    <div class="content">
      <ul class="clearfix" v-show="allpack">
        <li class="fl" v-for="(item,index) in list" :key="index" @click="gopackdetail(item.id)" style=" cursor: pointer;">
          <div class="kechengbox one">
            <img :src="item.img_url" alt class="bigimg" />
            <div class="opction"></div>
            <!--<span>购买后永久有效</span>
            <span v-if="item.isBuy==1">学习进度：{{item.jindu}}%</span>-->
            <span ></span>
            <span>开始学习</span>
          </div>
          <div class="two fl" style=" cursor: pointer;">
            <p>{{item.title}}</p>
          </div>
          <div class="three fr">
            <p>
              <span>学时:</span>
              <span>{{item.xueshi_num}}</span>
              <!--<span>￥{{item.price}}元</span>
              <span>价格:</span> -->
            </p>
            <!-- <p :class="{active:item.isBuy==1}" @click.stop="xuexi(item.id)">{{item.isBuy=="0"?"购买":"继续学习"}}</p> -->
          </div>
        </li>
      </ul>
      <div class="nodata" v-show="nodata"></div>
      <div class="blocks">
        <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo" :page-size="6"
          layout="total,prev, pager, next, jumper" :total="count" :pager-count="7" v-show="count>6">
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  import Vue from 'vue'
  export default {
    name: "mypackage",
    data() {
      return {
        kecheng_type: [],
        pack: 0,
        type: 1,
        uid: '',
        token: '',
        list: [],
        year: '',
        idd: '',
        
        fenye: true,
        count: 0,
        page: 1,
        num: 6,
        pageNo: 1,
        mydata: [],
        allpack: true,
        mypack: false,
        count1: 0,
        tabs: ["全部课程",
          /* "专业课", "公需课", */
        ],
        nodata: true,
        ProductActive: '0',
        ProductActives: '0',
        bol1: false,
        bol2: false
      };
    },
    created() {
      this.uid = localStorage.getItem("uid");
      this.token = localStorage.getItem("token");
      var date = new Date();
      this.year = date.getFullYear();
      this.kechengbao()
      if (sessionStorage.getItem('nums')) {
        this.tab(sessionStorage.getItem('nums'))
      }
    },
    watch: {
      token: {
        handler: function(val) {
          if (val) {
            // this.kechengbao();
          } else {
            this.$router.push('/')
            this.removeInfo()
          }
        }
      },
      deep: true
    },
    methods: {
      // changeProducts(event) {
      //   this.ProductActives = event.target.value; //获取商品ID，即option对应的ID值
      //   // (this.ProductActives)
      //   // (this.ProductActive)
      //   // (this.pack)
      //   if (this.ProductActives == '0') {
      //     this.kechengbao_z();
      //   } else if (this.ProductActives >= '0' && this.ProductActives == this.ProductActives) {
      //     var that = this
      //     var type = {
      //       year: this.ProductActive,
      //       category_id: this.ProductActives,
      //       type: this.pack
      //     }
      //     this.$axios({
      //       method: "post",
      //       url:  "/kecheng/get_kechengbao_list",
      //       data: qs.stringify(type)
      //     }).then(res => {
      //       // (res);
      //       if (res.data.status == "ok") {
      //         that.list = [];
      //         that.list = that.list.concat(res.data.data.data);
      //         that.count = Number(res.data.data.count);
      //         for (var i = 0; i < that.list.length; i++) {
      //           Vue.set(that.list[i], "isBuy", "0");
      //           Vue.set(that.list[i], "jindu", "0");
      //           that.isBuy(that.list[i].id);
      //           that.getprogress1(that.list[i].id);

      //         }
      //         if (that.count > 0) {
      //           that.nodata = false
      //         } else {
      //           that.nodata = true
      //         }
      //       } else if (res.data.status == "error") {
      //         this.$message.error({
      //           message: res.data.errormsg,
      //           duration: 1600
      //         });
      //       } else if (res.data.status == "relogin") {
      //         that.removeInfo();
      //       }
      //     });
      //   }
      // },
      // changeProduct(event) {
      //   this.ProductActive = event.target.value; //获取商品ID，即option对应的ID值
      //   // (this.ProductActive)
      //   if (this.ProductActive == this.ProductActive) {
      //     // ('111111111');
      //     var type = {
      //       year: this.ProductActive,
      //       category_id: this.ProductActives,
      //       type: this.pack
      //     }
      //     this.$axios({
      //       method: "post",
      //       url:  "/kecheng/get_kechengbao_list",
      //       data: qs.stringify(type)
      //     }).then(res => {
      //       // (res);
      //       if (res.data.status == "ok") {
      //         that.list = [];
      //         that.list = that.list.concat(res.data.data.data);
      //         that.count = Number(res.data.data.count);
      //         for (var i = 0; i < that.list.length; i++) {
      //           Vue.set(that.list[i], "isBuy", "0");
      //           Vue.set(that.list[i], "jindu", "0");
      //           that.isBuy(that.list[i].id);
      //           that.getprogress1(that.list[i].id);

      //         }
      //         if (that.count > 0) {
      //           that.nodata = false
      //         } else {
      //           that.nodata = true
      //         }
      //       } else if (res.data.status == "error") {
      //         this.$message.error({
      //           message: res.data.errormsg,
      //           duration: 1600
      //         });
      //       } else if (res.data.status == "relogin") {
      //         that.removeInfo();
      //       }
      //     });
      //   }
      // },
      // 获取年份分类
      // all_() {
      //   let that = this;
      //   this.$axios({
      //     method: 'get',
      //     url:  '/kecheng/get_kecheng_year',
      //   }).then(function(response) {
      //     if (response.data.status == "ok") {
      //       // // ("课程年份")
      //       // // (response.data.data)
      //       that.kecheng_year = response.data.data;
      //     } else if ((response.data.status == "error")) {
      //       that.$message.error({
      //         message: response.data.errormsg,
      //         duration: 1600
      //       });
      //     } else if ((response.data.status == "relogin")) {
      //       that.removeInfo();
      //     }
      //   });
      // },
      // //获取课程分类
      // all_type() {
      //   let that = this;
      //   this.$axios({
      //     method: 'get',
      //     url:  '/kecheng/get_kecheng_category',
      //   }).then(function(response) {
      //     if (response.data.status == "ok") {
      //       // ("课程类型")
      //       // (response.data.data)
      //       that.kecheng_type = response.data.data;
      //     } else if ((response.data.status == "error")) {
      //       that.$message.error({
      //         message: response.data.errormsg,
      //         duration: 1600
      //       });
      //     } else if ((response.data.status == "relogin")) {
      //       that.removeInfo();
      //     }

      //   });
      // },
      // changeTab: function(index) {
      //   this.pack = index;
      //   sessionStorage.setItem('pack', this.pack)
      //   if (index == 0) {
      //     this.kemuid = "";
      //     this.page = 1;
      //     this.kechengbao();
      //     this.bol1 = false;
      //     this.bol2 = false;
      //   } else if (index == 1) {
      //     this.kemuid = 1;
      //     this.page = 1;
      //     this.kechengbao_z();
      //     this.bol1 = true;
      //     this.bol2 = true;
      //   } else if (index == 2) {
      //     this.kemuid = 2;
      //     this.page = 1;
      //     this.kechengbao_g();
      //     this.bol1 = true;
      //     this.bol2 = false;
      //   }
      // },
      tab(num) {
        var that = this
        this.type = num;
        sessionStorage.setItem('nums', num)
        //  (num)
        if (num == 0) {
          this.mypackage()
          this.mypack = true
          this.allpack = false
        } else {
          this.mypack = false
          this.allpack = true
          //  (that.count)
          if (that.count > 0) {
            that.nodata = false

          } else {
            that.nodata = true
          }
        }
      },
      //获取全部课程包
      kechengbao() {
        var that = this;
        this.$axios({
          method: "post",
          url:  "/kecheng/get_kechengbao_list",
          data: qs.stringify({
            /* year: this.year, */
            page: this.page,
            num: this.num
          })
        }).then(res => {
          //  (res);
          if (res.data.status == "ok") {
            that.list = [];
            that.list = that.list.concat(res.data.data.data);
            that.count = Number(res.data.data.count);
            //  (that.count)
            if (that.count > 0) {
              that.nodata = false
            } else {
              that.nodata = true
            }
            for (var i = 0; i < that.list.length; i++) {
              Vue.set(that.list[i], "isBuy", "0");
              Vue.set(that.list[i], "jindu", "0");
              that.isBuy(that.list[i].id);
             // that.getprogress1(that.list[i].id);

            }

          } else if (res.data.status == "error") {
            this.$message.error({
              message: res.data.errormsg,
              duration: 1600
            });
          } else if (res.data.status == "relogin") {
            that.removeInfo();
          }
        });
      },
      //各个课程包是否购买
      isBuy: function(id) {
        let that = this;
        let courseId = {
          uid: this.uid,
          token: this.token,
          kecheng_bao_id: id
        };
        this.$axios
          .post(
             "/kecheng/check_kecheng_bao_is_buy",
            qs.stringify(courseId)
          )
          .then(res => {
            // ("李四");
            // (res);
            if (res.data.status == "ok") {
              for (var i = 0; i < that.list.length; i++) {
                if (res.data.data["kecheng_bao_id"] == that.list[i].id) {
                  Vue.set(that.list[i], "isBuy", res.data.data.check_res);
                  break;
                }
              }
            } else if (res.data.status == "error") {
              this.$message.error({
                message: res.data.msg,
                duration: 1600
              });
            } else if (res.data.status == "relogin") {
              that.removeInfo();
            }
          });
      },
      //分页
      handleCurrentChange(val) {
        this.page = val
        // (`当前页: ${val}`);
        this.kechengbao()
      },
      //分页
      handleCurrentChange1(val) {
        this.page = val
        // (`当前页: ${val}`);
        this.mypackage()
      },
      removeInfo() {
        var that = this
        this.$message.error({
          message: "重新登录",
          duration: 1600
        });
        localStorage.removeItem("uid");
        localStorage.removeItem("token");
        localStorage.removeItem("sex");
        localStorage.removeItem("name");
        localStorage.removeItem("mobile");
        localStorage.removeItem("id_card");
        setTimeout(() => {
          that.$router.push({
            path: '/'
          });
        }, 1600);
      },
      xuexi(packageid) {
        let that = this;
        let courseId = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          kecheng_bao_id: packageid
        }
        this.$axios.post( '/kecheng/check_kecheng_bao_is_buy', qs.stringify(courseId))
          .then(res => {
            // ("错误信息")
            // (res)
            if (res.data.status == "ok") {
              if (res.data.data.check_res == "0") {
                this.$router.push({
                  path: 'packagebuy',
                  query: {
                    packid: packageid
                  }
                });
              } else if (res.data.data.check_res == "1") {
                that.gopackdetail(packageid);
              }
            } else if (res.data.status == "error") {
              this.$message.error({
                message: res.data.msg,
                duration: 1600
              });
            } else if (res.data.status == "relogin") {
              that.removeInfo();
            }

          });

      },
      gopackdetail(id) {
        this.$router.push({
          path: '/personalpackage',
          query: {
            codeid: id
          }
        })
      },
      //我的课程包
      // mypackage() {
      //   var that = this
      //   var data = {
      //     uid: this.uid,
      //     token: this.token,
      //     year: this.year,
      //     page: this.page,
      //     num: this.num,
      //   }
      //   this.$axios.post('/kecheng/get_kechengbao_list_for_buy',
      //     qs.stringify(data)).then(res => {
      //     // ("获取我的课程包")
      //     // (res)
      //     if (res.data.status == "ok") {
      //       that.mydata = [];
      //       that.mydata = that.mydata.concat(res.data.data.data)
      //       that.count1 = Number(res.data.data.count);
      //       if (that.count1 > 0) {
      //         that.nodata = false
      //       } else {
      //         that.nodata = true
      //       }
      //       for (var i = 0; i < that.mydata.length; i++) {
      //         Vue.set(that.mydata[i], "jindu", "0");
      //         this.getprogress(that.mydata[i].id);
      //       }

      //     }

      //   })
      // },
      // //我的课程包进度
      // getprogress(num) {
      //   var that = this
      //   this.$axios.post("/kecheng/get_kecheng_bao_jindu", qs.stringify({
      //     kecheng_bao_id: num,
      //     uid: this.uid,
      //     token: this.token
      //   })).then(res => {
      //      ("获取我的课程进度11111111")
      //      (res)
      //     if (res.data.status == "ok") {
      //       for (var i = 0; i < that.mydata.length; i++) {
      //         if (that.mydata[i].id == res.data.data['kecheng_bao_id']) {
      //           Vue.set(that.mydata[i], "jindu", parseInt(res.data.data.progress))
      //           break
      //         }
      //       }
      //     }
      //   })
      // },
      // //全部课程包进度
      // getprogress1(num) {
      //   var that = this
      //   this.$axios.post("http://jixujiaoyu_api.songlongfei.club:1012/kecheng/get_kecheng_bao_jindu", qs.stringify({
      //     kecheng_bao_id: num,
      //     uid: this.uid,
      //     token: this.token
      //   })).then(res => {
      //     // ("获取我的课程进度")
      //     // (res)
      //     if (res.data.status == "ok") {
      //       for (var n = 0; n < that.list.length; n++) {
      //         if (that.list[n].id == res.data.data['kecheng_bao_id']) {
      //           Vue.set(that.list[n], "jindu", parseInt(res.data.data.progress))
      //           break
      //         }
      //       }
      //     }
      //   })
      // },
    },
    mounted() {
      //this.all_();
     // this.all_type();
      this.kechengbao()
    }
  };
</script>

<style lang="less" scoped>
  .opction {
    height: 42px;
    width: 238px;
    background: #000;
    opacity: 0.5;
    margin-top: -42px;
    position: relative;
  }

  .mypackage {
    width: 948px;
    min-height: 708px;
    background-color: #fff;
    box-sizing: border-box;
    h3 {

      // color:#0169cc;
      span {
        cursor: pointer;

        &:nth-child(1) {
          margin-right: 30px;
        }

        &.active {
          color: #ad0008;
          padding-bottom: 13px;
          border-bottom: 2px solid #0169cc;
          box-sizing: border-box;
        }
      }

    }

    // .selection-component {
    //   height: 35px;
    //   width: 100px;
    //   border: 1px #d3d3d3 solid;
    //   float: right;
    //   color: #f00;
    //   font-size: 16px;
    //   margin: 21px 21px 0 0;
    //   display: block;
    //   padding: 0 5px;

    //   img {
    //     position: absolute;
    //     top: 0;
    //     right: 0;
    //     height: 5px;
    //     width: 10px;
    //   }
    // }

    .curspan {
      border-bottom: 2px solid #ad0008;
      padding-bottom: 13px;
      color: #ad0008;
      position: relative;
    }

    .content {
      width: 100%;
      min-height: 662px;
      position: relative;
      overflow: hidden;
      ul{
        min-height:600px;
        position:relative;
        li {
          width: 260px;
          // height: 255px;
          margin-left: 32px;
          min-height:240px;
          margin-top: 15px;
          border: 1px solid #dfe4ed;
          border-radius: 5px;
          padding: 10px;
          background-color: #fff;
          position:relative;
          .kechengbox{
                  .biaozhi{position: absolute;left: 0;top: 10px;
                    img{width: 50px;height: 20px;}
                  }
                  .bigimg{
                    width: 100%;
                    height: 144px;
                    //border-radius: 5px;
                    overflow: hidden;
                  }
          }
          .one {
            span {
              color: #fff;
              position: absolute;
            }

            span:nth-child(3) {
              left: 11px;
              top: 140px;
            }

            span:nth-child(4) {
              right: 20px;
              top: 125px;
            }

            img {
              height: 166px;
              width: 252px;
            }
          }

          .two {
            padding: 15px 0;
            box-sizing: border-box;
            cursor: default;

            h3 {
              font-weight: bold;
              color: #111;
              margin-bottom: 25px;
            }

            p:nth-child(1) {
              position: absolute;
              left: 10px;
              top: 170px;
              font-size: 18px;
              width:228px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              span {
                color: #111;

                &:nth-child(1) {
                  margin-right: 10px;
                }
              }
            }
          }

        .three {
          padding: 20px 10px;
          box-sizing: border-box;
          cursor: default;

          p:nth-child(1) {
            position: absolute;
            left: 10px;
            bottom: 12px;
            color: #111;
            font-size: 15px;
            height: 20px;
            width: 252px;

            span:nth-child(2) {
              color: #f00;
            }

            span:nth-child(3),
            span:nth-child(4) {
              float: right;
            }

            span:nth-child(3) {
              font-size: 15px;
              color: #fe4040;
              margin-right: 20px;
            }
          }

          p:nth-child(2) {
            margin-top: 40px;
            color: red;
            width: 130px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background-color: #fe4040;
            color: #fff;
            font-size: 16px;
            cursor: pointer;
          }

          p.active {
            background-color: #0169cc;
            color: #fff;
          }
        }
      }
    }
      .nodata {
        width: 212px;
        height: 240px;
        margin: 80px auto;
        background-image: url('../assets/nodata.png');
      }
      .blocks{
        position: absolute;bottom: 50px; text-align:center;width: 100%; height:50px; padding-top:8px;
      }
    }
  }

  .title {
    width: 100%;
    height: 55px;
    // margin-bottom: 20px;
    font-size: 18px;
    padding-left: 35px;
    line-height: 55px;
    color: #0c69f5;
    box-sizing: border-box;
    border-bottom: 2px solid #eee;

    span {
      margin-right: 20px;
      cursor: pointer;
      color: #b9b9b9;
    }

    .selection-component {
      height: 35px;
      width: 100px;
      background: url('../assets/1.jpg') no-repeat;
      background-position: 74px 11px;
      text-align: center;
      float: right;
      color: #f00;
      font-size: 16px;
      // margin: 21px 21px 0 0 ;
      // padding:0 5px;
      position: relative;
      top: -13px;

      img {
        position: absolute;
        top: 0;
        right: 0;
        height: 5px;
        width: 10px;
      }
    }

    .curspan {
      border-bottom: 2px solid #ad0008;
      padding-bottom: 13px;
      color: #ad0008;
    }
  }
</style>
<style lang="less">
  .mypackage {
    .el-progress-bar {
      width: 95%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mypackage.vue